import { Box } from "@chakra-ui/react";
import { Team } from "common";
import { useMemo } from "react";
import { MAX_NAVBAR_WIDTH } from "../config";
import { LeaderboardPanelItem } from "./LeaderboardPanelItem";

interface LeaderboardPanelProps {
  // Assumes the teams are already sorted
  teams: Team[];
}

export const LeaderboardPanel = ({ teams }: LeaderboardPanelProps) => {
  const team1: Team | undefined = useMemo(() => teams[0], [teams]);
  const team2: Team | undefined = useMemo(() => teams[1], [teams]);
  const team3: Team | undefined = useMemo(() => teams[2], [teams]);
  return (
    <Box
      display={"flex"}
      width={"100%"}
      padding={4}
      alignItems={"flex-end"}
      maxWidth={MAX_NAVBAR_WIDTH}
      justifyContent={"center"}
    >
      {team2 ? (
        <LeaderboardPanelItem
          team={team2}
          isFirst={false}
          paddingBottom={4}
          position={2}
        />
      ) : null}
      {team1 ? (
        <LeaderboardPanelItem
          team={team1}
          isFirst={true}
          paddingBottom={8}
          position={1}
        />
      ) : null}
      {team3 ? (
        <LeaderboardPanelItem
          team={team3}
          isFirst={false}
          paddingBottom={0}
          position={3}
        />
      ) : null}
    </Box>
  );
};
